/*
  ** Menu.jsx **
  Monta o menu em suas versão desktop e celular
*/

import React, { useState, useRef, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import NavbarLink from "../../elements/NavbarLink";
import classnames from "classnames";
import Drawer from "rc-drawer";
import ImgLogo from "../../assets/images/logo_UOL_Final.svg";
import Lupa from "../../assets/images/icone-Busca-Ativa.svg";
import "../../assets/scss/components/menu.scss";
import DropdownMenu from "../Dropdown";

function Menu() {
  const [open, setOpen] = useState(false);
  const [container, setContainer] = useState({});
  const [changeBackground, setChangeBackground] = useState(false);
  const [searchInputVisible, setSearchInputVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    if (searchText.trim()) {
      const searchUrl = `https://painel.play.uol.com.br/busca?q=${searchText}`;
      window.location.href = searchUrl;
      setSearchText("");
    }
  };

  const baseURLPannel = "https://painel.play.uol.com.br";

  function handleScroll() {
    const scrollPos = window.pageYOffset;
    if (scrollPos >= 50) {
      setChangeBackground(true);
    } else {
      setChangeBackground(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function getContainer() {
    return container;
  }

  function saveContainer(el) {
    setContainer(el);
  }

  function toggleDrawer() {
    setOpen(!open);
  }

  const searchInput = useRef(null);

  function handleOpenSearchInput() {
    if (searchInput.current) {
      searchInput.current.focus();
    }

    setSearchInputVisible(!searchInputVisible);
  }

  const canaisMenuItem = [
    { text: "Universal+", url: "https://play.uol.com.br/lp/universalplus" },
    { text: "HBO Max", url: "https://play.uol.com.br/lp/max" },
    { text: "Paramount+", url: "https://play.uol.com.br/lp/paramountplus" },
    { text: "UFC Fight Pass", url: "https://play.uol.com.br/lp/esportes/ufc" },
    { text: "NBA", url: "https://play.uol.com.br/lp/esportes/nba" },
    {
      text: "BandSports",
      url: "https://play.uol.com.br/lp/esportes/band-bandsports",
    },
    { text: "AXN", url: "https://play.uol.com.br/lp/axn" },
    { text: "Sony Channel", url: "https://play.uol.com.br/lp/sony-channel" },
    {
      text: "History Channel",
      url: "https://play.uol.com.br/lp/history-channel",
    },
    {
      text: "UOL Originais",
      url: "https://play.uol.com.br/lp/uol-play-originais",
    },
  ];

  const catalogoMenuItem = [
    {
      text: "Universal+",
      url: "https://painel.play.uol.com.br/1163",
      border: false,
    },
    {
      text: "UOL Originais",
      url: "https://painel.play.uol.com.br/uol-originais",
      border: false,
    },
    {
      text: "Paramount+",
      url: "https://painel.play.uol.com.br/paramount",
      border: true,
    },
    {
      text: "Ação e aventura",
      url: "https://painel.play.uol.com.br/acao-e-aventura",
      border: false,
    },
    {
      text: "Comédia",
      url: "https://painel.play.uol.com.br/comedia",
      border: false,
    },
    {
      text: "Drama",
      url: "https://painel.play.uol.com.br/drama",
      border: false,
    },
    {
      text: "Família e infantil",
      url: "https://painel.play.uol.com.br/familia-e-infantil",
      border: false,
    },
    {
      text: "Ficção científica",
      url: "https://painel.play.uol.com.br/ficcao-cientifica",
      border: false,
    },
    {
      text: "Romance",
      url: "https://painel.play.uol.com.br/romance",
      border: false,
    },
    {
      text: "Suspense e terror",
      url: "https://painel.play.uol.com.br/suspense-e-terror",
      border: false,
    },
    {
      text: "Esportes",
      url: "https://painel.play.uol.com.br/esportes",
      border: true,
    },
    // { text: "Filmes", url: "", border: false },
    {
      text: "Séries",
      url: "https://painel.play.uol.com.br/series",
      border: false,
    },
  ];

  return (
    <>
      <div ref={saveContainer} />
      <Navbar
        id="menu"
        className={classnames("menu", "div-pad", { scroll: changeBackground })}
        bg="justify-content-between"
        fixed="top"
      >
        <div className="toggle-drawer">
          <div className="mobile-btn">
            <span
              className={open ? "mobile-icon is-active" : "mobile-icon"}
              onClick={toggleDrawer}
            >
              <span></span>
              <div className={open ? "mobile-icon is-active" : null}></div>
            </span>
          </div>
          <Link to="/">
            <img
              className={`logo mobile ${searchInputVisible && "logo-hidden"}`}
              src={ImgLogo}
              alt="UOL Play"
              title="UOL Play"
            />
          </Link>
        </div>
        <Navbar.Collapse>
          <Link to="/" alt="UOL Play" title="UOL Play">
            <img
              className="navbar-brand"
              src={ImgLogo}
              alt="UOL Play"
              title="UOL Play"
            />
          </Link>
          <Nav className="mr-auto">
            <NavDropdown renderMenuOnMount title="Canais">
              {canaisMenuItem.map((canal, index) => (
                <NavDropdown.Item
                  key={index}
                  href={canal.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {canal.text}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <NavDropdown renderMenuOnMount title="Catálogo">
              {catalogoMenuItem.map((canal, index) => (
                <NavDropdown.Item
                  key={index}
                  // as={Link}
                  href={canal.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: `${
                      canal.border ? "1px solid #626262" : null
                    }`,
                  }}
                >
                  {canal.text}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <NavbarLink
              text="Programação ao vivo"
              baseURLPannel={baseURLPannel}
              suffixURLPannel="/ao-vivo"
              target="_blank"
              rel="noopener noreferrer"
            ></NavbarLink>

            <Nav.Link
              href="https://www.uol.com.br/play/colunas/uol-play/?utm_source=header_organic_botao-pv&utm_medium=header&utm_campaign=header_organic_botao-pv"
              target="_blank"
              rel="noopener noreferrer"
            >
              Blog
            </Nav.Link>
            <Nav.Link href="/planos">Planos</Nav.Link>
            <Nav.Link href="#faq">Dúvidas</Nav.Link>
            <Nav.Link
              href="https://play.uol.com.br/como-acessar/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Como acessar
            </Nav.Link>
          </Nav>

          <Nav>
            <div className="search-container">
              <form onSubmit={handleSearchSubmit} className="search-form">
                <button
                  className="search-button"
                  onClick={handleOpenSearchInput}
                >
                  <img
                    className="lupa"
                    src={Lupa}
                    alt="buscar"
                    title="buscar"
                  />
                </button>
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Filmes, atores, séries, desenhos"
                  ref={searchInput}
                  className={`${searchInputVisible ? "search-open" : ""}`}
                  onBlur={() => setSearchInputVisible(false)}
                />
              </form>
            </div>

            <Nav.Link
              href="https://painel.play.uol.com.br/selecionar-perfil"
              id="enter-button"
            >
              Entrar
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* menu mobile */}
      <Drawer
        className="menu-mobile"
        width="315px"
        handler={false}
        open={open}
        onClose={toggleDrawer}
        getContainer={getContainer}
      >
        <ul>
          <li>
            <DropdownMenu title="Canais" subItensList={canaisMenuItem} />
          </li>
          <li>
            <DropdownMenu title="Catálogo" subItensList={catalogoMenuItem} />
          </li>
          <li onClick={toggleDrawer}>
            <a href="https://painel.play.uol.com.br/ao-vivo">
              Programação ao vivo
            </a>
          </li>
          <li onClick={toggleDrawer}>
            <a
              href="https://www.uol.com.br/play/colunas/uol-play/?utm_source=header_organic_botao-pv&utm_medium=header&utm_campaign=header_organic_botao-pv"
              target="_blank"
              rel="noopener noreferrer"
            >
              Blog
            </a>
          </li>
          <li onClick={toggleDrawer}>
            <a href="#plans">Planos</a>
          </li>
          <li onClick={toggleDrawer}>
            <a href="/#faq">Dúvidas</a>
          </li>
          <li onClick={toggleDrawer}>
            <a href="https://play.uol.com.br/como-acessar/index.html">
              Como acessar
            </a>
          </li>
        </ul>
      </Drawer>
    </>
  );
}

export default Menu;
